module.exports = __webpack_public_path__ + "static/img/4.eb7dfbd8.png";